<template>
    <div class="graph" :style="`height:${height}; width:${width}`">

        <canvas :id="id" :width="500 * 2" :height="400"></canvas>
      
    </div>
</template>

<script>
    export default {

        props: {
            data: Array,
            labels: Array,
            id:String,
            width : {
                type : String,
                default : 'auto'
            },
            height : {
                type : String,
                default : 'auto'
            },
            primaryColor: {
                type: Array,
                default: function() {
                    return [107, 31, 77];
                }
            }
        },

      

        data() {
            return {
                chart: null,
                gradiantPrimaryColorHsl : [],
                countDataTypeBar : 0,
                countDataTypeLine : -1
            }
        },

        mounted () {
            this.initGradiantPrimaryColor()
            this.createChart()
            
        },

        watch: {
            data() {
                this.initGradiantPrimaryColor()
                this.updateChat()
            },

            labels() {
                this.initGradiantPrimaryColor()
                this.updateChat()
            },
        },

        methods: {
            createChart() {
                this.countDataTypeBar = -1
                this.countDataTypeLine = -1
                let datasets = this.data.map(d => ({
                    label: d.label,
                    data: d.data,
                    name: 'clics',
                    type: d.type,
                    yAxisID: `y-axis-${d.type}`,
                    ...this.getOptionElmtDatasets(d)
                }))

                // eslint-disable-next-line no-undef
                this.chart = new Chart(this.id, {
                    
                    data : {
                        labels: this.labels,
                        datasets: datasets
                    },
                    options: {
                        maintainAspectRatio: false,
                        stacked: false,
                        scales: {
                            ['y-axis-line'] : {
                                display : this.data.find(d => (d.type == 'line')) ? true : false,
                                grid: {
                                    color: "#F1EDF5", // Couleur de la grille
                                    lineWidth: 1.0, // Modifier l'épaisseur de la grille
                                    display : this.data.find(d => (d.type == 'bar')) ? false : true
                                },
                                ticks: {
                                    font: {
                                        size: 11, // Taille de la police
                                        weight: 'normal', // Poids de la police
                                    },
                                    color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                                    // stepSize: 5 // Taille du pas entre chaque tick
                                    beginAtZero: true
                                    
                                },
                                border : {
                                    color: "#F1EDF5"
                                },
                                position: this.data.find(d => (d.type == 'bar')) ? 'right' : 'left',
                            },
                            ['y-axis-bar'] : {
                                display : this.data.find(d => (d.type == 'bar')) ? true : false,
                                grid: {
                                    color: "#F1EDF5", // Couleur de la grille
                                    lineWidth: 1.0, // Modifier l'épaisseur de la grille
                                },
                                ticks: {
                                    font: {
                                        size: 11, // Taille de la police
                                        weight: 'normal', // Poids de la police
                                    },
                                    color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                                    //// stepSize: 5 // Taille du pas entre chaque tick
                                    //beginAtZero: true
                                },
                                border : {
                                    color: "#F1EDF5"
                                },
                            },
                            x: {
                                grid: {
                                    color: "#F1EDF5", // Couleur de la grille
                                    lineWidth: 1.0 // Modifier l'épaisseur de la grille
                                },
                                ticks: {
                                    font: {
                                        size: 11, // Taille de la police
                                        weight: 'normal', // Poids de la police
                                    },
                                    color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                                    // stepSize: 5 // Taille du pas entre chaque tick
                                    beginAtZero: true
                                },
                                border : {
                                    color: "#F1EDF5"
                                },
                                stacked: true
                            }
                        },

                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                display: true,
                                position: "bottom",
                                align: "center",
                                reverse:true,
                                labels: {

                                    color: '#555E75',
                                    strokeStyle : 'transparent',
                                    usePointStyle: true, //legend en square
                                    //pointStyle: 'line',
                                    padding: 20,
                                },
                                //usePointStyle: true,
                                
                            }
                        }
                    },

                })
                console.log("createChartt",this.chart )
            },
            updateChat() {
                console.log("updateChat slidegraph")
                this.countDataTypeBar = -1


                let datasets = this.data.map(d => ({
                    label: d.label,
                    data: d.data,
                    name: 'clics',
                    type: d.type,
                    yAxisID: `y-axis-${d.type}`,
                    ...this.getOptionElmtDatasets(d)
                }))


                this.chart.data.datasets = datasets
                this.chart.data.labels = this.labels
                
                this.chart.options.scales['y-axis-line'] = {
                    display : this.data.find(d => (d.type == 'line')) ? true : false,
                    grid: {
                        color: "#F1EDF5", // Couleur de la grille
                        lineWidth: 1.0, // Modifier l'épaisseur de la grille
                        display : this.data.find(d => (d.type == 'bar')) ? false : true
                    },
                    ticks: {
                        font: {
                            size: 11, // Taille de la police
                            weight: 'normal', // Poids de la police
                        },
                        color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                        // stepSize: 5 // Taille du pas entre chaque tick
                        beginAtZero: true
                        
                    },
                    border : {
                        color: "#F1EDF5"
                    },
                    position: this.data.find(d => (d.type == 'bar')) ? 'right' : 'left',
                }

                this.chart.options.scales['y-axis-bar'] = {
                    display : this.data.find(d => (d.type == 'bar')) ? true : false,
                    grid: {
                        color: "#F1EDF5", // Couleur de la grille
                        lineWidth: 1.0, // Modifier l'épaisseur de la grille
                        stacked: true
                    },
                    ticks: {
                        font: {
                            size: 11, // Taille de la police
                            weight: 'normal', // Poids de la police
                        },
                        color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                        // stepSize: 5 // Taille du pas entre chaque tick
                        beginAtZero: true
                    },
                    border : {
                        color: "#F1EDF5"
                    },
                    stacked: true
                }
                this.chart.options.scales.x = {
                    grid: {
                        color: "#F1EDF5", // Couleur de la grille
                        lineWidth: 1.0 // Modifier l'épaisseur de la grille
                    },
                    ticks: {
                        font: {
                            size: 11, // Taille de la police
                            weight: 'normal', // Poids de la police
                        },
                        color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                        // stepSize: 5 // Taille du pas entre chaque tick
                        beginAtZero: true
                    },
                    border : {
                        color: "#F1EDF5"
                    },
                    stacked: true
                }
                

                this.chart.update()
                console.log("chart",this.chart)
            },
            getOptionElmtDatasets(data) {
                switch (data.type) {
                    case "line":
                        this.countDataTypeLine++
                        return {
                            tension: 0.4, //smooth la courb
                            fill: false,
                            borderColor: ['#6B1F4D','#B64985'][this.countDataTypeLine],
                            borderWidth: 4,
                            borderRadius: 20,
                            pointRadius: 0,
                        }
                    case "bar":
                        this.countDataTypeBar++
                        console.log(`hsl(${this.gradiantPrimaryColorHsl[this.countDataTypeBar].map((number,index) => (index > 0 ? number.toString()+'%' : number.toString())).join(',')})`)
                        return {
                           
                            ////tension: 0.4, //smooth la courbe
                            ////fill: `hsl(${this.gradiantPrimaryColorHsl[this.countDataTypeBar].map((number,index) => (index > 0 ? number.toString()+'%' : number.toString())).join(',')})`,
                            backgroundColor: `hsl(${this.gradiantPrimaryColorHsl[this.countDataTypeBar].map((number,index) => (index > 0 ? number.toString()+'%' : number.toString())).join(',')})`, //format en format hsl (ajout % au deux last value)
                            ////borderColor: '#6B1F4D',
                            borderWidth: 0,
                            ////borderRadius: 20,
                            pointRadius: 0,
                            barThickness: 10,
                        }
                    default:
                        return {}
                }

            },

            initGradiantPrimaryColor() {
                //itialise une liste de couleur prenant la couleur primaire comme reference,
                //Les couleurs sont de plus en plus claire
                //Nous calculons le nombre de data de type bar afin de favoriser une meilleur variété de couleur
                //ex 4 data type bar, alors 4 couleurs
                //Les dégradé de couleur sert qu'un type bars

                let countDataTypeBar = this.data.filter((d) => d.type == 'bar').length;
                let colorHsl = this.rgbToHsl(this.primaryColor[0], this.primaryColor[1], this.primaryColor[2])

                if (colorHsl[2] + 20*(countDataTypeBar-1) > 90) {
                    colorHsl[2] = 100 - 20*countDataTypeBar
                }
                
                this.gradiantPrimaryColorHsl = [colorHsl]
  
                for (let i = 2; i <= countDataTypeBar; i++) {
                    this.gradiantPrimaryColorHsl.push([colorHsl[0],colorHsl[1],this.gradiantPrimaryColorHsl[this.gradiantPrimaryColorHsl.length-1][2] + 10])
                }

            },
            rgbToHsl(r, g, b){
                r /= 255;
                g /= 255;
                b /= 255;
                const l = Math.max(r, g, b);
                const s = l - Math.min(r, g, b);
                const h = s
                    ? l === r
                    ? (g - b) / s
                    : l === g
                    ? 2 + (b - r) / s
                    : 4 + (r - g) / s
                    : 0;
                return [
                    60 * h < 0 ? 60 * h + 360 : 60 * h,
                    100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
                    (100 * (2 * l - s)) / 2,
                ];
            }
        },
    }
</script>

